import { render } from "./PublicationItem.vue?vue&type=template&id=8cd48916"
import script from "./PublicationItem.vue?vue&type=script&lang=js"
export * from "./PublicationItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__